export type FileBrowserViewMode = 'details' | 'thumbnails';

export const FILE_BROWSER_VIEW_MODE_KEY = 'jarvis.fileBrowser.viewMode';

export function readFileBrowserViewMode(): FileBrowserViewMode {
  try {
    const value = localStorage.getItem(FILE_BROWSER_VIEW_MODE_KEY);
    return value === 'thumbnails' ? 'thumbnails' : 'details';
  } catch {
    return 'details';
  }
}

/** Respects an explicit saved preference; otherwise defaults to thumbnails on narrow layouts. */
export function readFileBrowserViewModeForLayout(isNarrow: boolean): FileBrowserViewMode {
  try {
    const value = localStorage.getItem(FILE_BROWSER_VIEW_MODE_KEY);
    if (value === 'thumbnails' || value === 'details') return value;
  } catch {
    // ignore quota / private mode errors
  }
  return isNarrow ? 'thumbnails' : 'details';
}

export function writeFileBrowserViewMode(mode: FileBrowserViewMode): void {
  try {
    localStorage.setItem(FILE_BROWSER_VIEW_MODE_KEY, mode);
  } catch {
    // ignore quota / private mode errors
  }
}

export function isFileBrowserViewMode(value: unknown): value is FileBrowserViewMode {
  return value === 'details' || value === 'thumbnails';
}
